import type { editor } from 'monaco-editor'

export const codeEditorThemeName = 'archer-code-light'

/** One reading palette for code, streaming proposals and revision comparisons. */
export const codeEditorTheme: editor.IStandaloneThemeData = {
  base: 'vs',
  // Built-in language-specific rules otherwise override these shared prefixes
  // (for example SQL operators keep the stock, low-contrast grey).
  inherit: false,
  rules: [
    { token: '', foreground: '25324A' },
    { token: 'comment', foreground: '526479' },
    { token: 'keyword', foreground: '2457A7' },
    { token: 'operator', foreground: '465A78' },
    { token: 'delimiter', foreground: '465A78' },
    { token: 'number', foreground: '7950A3' },
    { token: 'string', foreground: '9B3E2C' },
    { token: 'string.escape', foreground: '7950A3' },
    { token: 'string.key', foreground: '2457A7' },
    { token: 'type', foreground: '006D77' },
    { token: 'predefined', foreground: '006D77' },
    { token: 'predefined.function', foreground: '7950A3' },
    { token: 'tag', foreground: '2457A7' },
    { token: 'attribute.name', foreground: '006D77' },
    { token: 'key', foreground: '2457A7' },
    { token: 'invalid', foreground: 'B42318' },
  ],
  colors: {
    'editor.background': '#FFFFFF',
    'editor.foreground': '#25324A',
    'editorLineNumber.foreground': '#68778A',
    'editorLineNumber.activeForeground': '#304560',
    'editorCursor.foreground': '#2457A7',
    'editor.lineHighlightBackground': '#F5F7FB',
    'editor.lineHighlightBorder': '#00000000',
    'editor.selectionBackground': '#DCE9FA',
    'editor.inactiveSelectionBackground': '#ECF1F8',
    'editor.selectionHighlightBackground': '#DCE9FA80',
    'editor.findMatchBackground': '#FFE3A3',
    'editor.findMatchHighlightBackground': '#FFE3A366',
    'editorWhitespace.foreground': '#9AA7B8',
    'editorIndentGuide.background1': '#E4E9F1',
    'editorIndentGuide.activeBackground1': '#A5B3C7',
    'editorBracketMatch.background': '#EAF0FA',
    'editorBracketMatch.border': '#A5B3C7',
    'editorBracketHighlight.foreground1': '#465A78',
    'editorBracketHighlight.foreground2': '#7950A3',
    'editorBracketHighlight.foreground3': '#006D77',
    'editorBracketHighlight.foreground4': '#2457A7',
    'editorBracketHighlight.foreground5': '#9B3E2C',
    'editorBracketHighlight.foreground6': '#465A78',
    'editorGutter.background': '#FFFFFF',
    'editorGutter.addedBackground': '#27834B',
    'editorGutter.deletedBackground': '#C14C4C',
    'editorGutter.modifiedBackground': '#3B6CB4',
    'diffEditor.insertedLineBackground': '#EAF6ED',
    'diffEditor.removedLineBackground': '#FFF0EF',
    'diffEditor.insertedTextBackground': '#9EDCB54D',
    'diffEditor.removedTextBackground': '#F1A8A34D',
    'diffEditor.diagonalFill': '#E4E9F1',
    'diffEditor.border': '#E4E9F1',
    'scrollbarSlider.background': '#7B8AA04D',
    'scrollbarSlider.hoverBackground': '#7B8AA080',
    'scrollbarSlider.activeBackground': '#63738CA6',
  },
}
